/**
 * Sends a request to the server to send a one-time login code to the email address contained in the given body.
 * May redirect the user to the `/one-time-login-code/verify` page if the request was successful or throw an error.
 *
 * @throws {Error} with the message 'INVALID_EMAIL' if the email address is not a valid email address.
 *
 * @param body The body in the format of URLSearchParams to make the request with. Should contain
 *   values for the keys `email` and `_csrf`.
 * @param redirect Whether to redirect the user to the `/one-time-login-code/verify` page if the request was successful.
 *   Defaults to `true`.
 */
export async function sendOneTimeLoginCode(body, redirect = true) {
    const response = await fetch('/one-time-login-code/send' + window.location.search, {
        method: 'POST',
        body,
    });
    if (response.redirected && redirect) {
        window.location.href = response.url;
        return;
    }
    if (!response.ok) {
        const data = await response.json();
        // Forward the sanitized failure message as an error
        console.error(data);
        throw new Error(data.error);
    }
}
/**
 * Sends a reset password request to the server with the given email address. Redirects to a success page if the request
 * was successful.
 *
 * @param body The body in the format of URLSearchParams to make the request with. Should contain
 *   values for the keys `email` and `_csrf`.
 */
export async function resetPassword(body) {
    const response = await fetch('/forgotPassword', { method: 'POST', body });
    const html = await response.text();
    // Render the success page returned by the server
    document.body.innerHTML = html;
}
